import { Button } from "antd";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import MiniTable from "../../../components/mini-table";
import useFormatter from "../../../hooks/useFormatter";
import { compareStrings } from "../../../util/string";
import TableCellEllipsis from "../../../components/table-cell-ellipsis";

export default function EmpresaLicencasTable({ dataSource, loading, miniTableRef, onClick, onSelectedIdsChange, selectedIds, title }) {
  const { t } = useTranslation();
  const { formatDate } = useFormatter();

  const fireClick = (empresa) => (typeof onClick === "function" ? onClick(empresa) : undefined);

  const columns = [
    {
      title: t("Unidade"),
      dataIndex: ["unidade", "apelido"],
      key: "unidade",
      sorter: (a, b) => compareStrings(a.unidade?.apelido, b.unidade?.apelido),
      render: (text, record) => (
        <Button type="link" onClick={() => fireClick(record)}>
          {text ?? t("(não preenchido)")}
        </Button>
      ),
    },
    {
      title: t("Empresa"),
      dataIndex: ["empresa", "razaoSocial"],
      key: "razaoSocial",
      sorter: (a, b) => compareStrings(a.empresa?.razaoSocial, b.empresa?.razaoSocial),
      render: (text) => text ?? t("(não preenchido)"),
      hidden: true,
    },
    {
      title: t("Nome"),
      dataIndex: "nome",
      key: "nome",
      sorter: (a, b) => compareStrings(a.nome, b.nome),
    },
    {
      title: t("Órgão Emissor"),
      dataIndex: "orgaoEmissor",
      key: "orgaoEmissor",
      sorter: (a, b) => compareStrings(a.orgaoEmissor, b.orgaoEmissor),
      width: 100,
    },
    {
      title: t("Custo Total"),
      dataIndex: "custoTotal",
      key: "custoTotal",
      hidden: true,
      sorter: (a, b) => (a.custoTotal ?? 0) - (b.custoTotal ?? 0),
      render: (value) => value ?? t("(não informado)"),
    },
    {
      title: t("Data Inicial"),
      dataIndex: "dataInicial",
      key: "dataInicial",
      width: 100,
      sorter: (a, b) => compareStrings(a.dataInicial, b.dataInicial),
      render: (text, record) => formatDate(record.dataInicial),
    },
    {
      title: t("Indeterminado"),
      dataIndex: "indeterminado",
      key: "indeterminado",
      hidden: true,
      render: (value) => (value ? t("Sim") : t("Não")),
    },
    {
      title: t("Data Final"),
      dataIndex: "dataFinal",
      key: "dataFinal",
      width: 100,
      sorter: (a, b) => compareStrings(a.dataFinal, b.dataFinal),
      render: (text, record) => (record.indeterminado ? t("Indeterminado") : formatDate(record.dataFinal)),
    },
    {
      title: t("Aviso (dias)"),
      dataIndex: "aviso",
      key: "aviso",
      hidden: true,
      render: (value) => (value != null && value >= 0 ? value : t("Não informado")),
    },
    {
      title: t("Site"),
      dataIndex: "site",
      key: "site",
      sorter: (a, b) => compareStrings(a.site, b.site),
      hidden: true,
    },
    {
      title: t("Login"),
      dataIndex: "login",
      key: "login",
      hidden: true,
      sorter: (a, b) => compareStrings(a.login, b.login),
      render: (value) => value ?? t("(não informado)"),
    },
    {
      title: t("Senha"),
      dataIndex: "senha",
      key: "senha",
      hidden: true,
      sorter: (a, b) => compareStrings(a.senha, b.senha),
      render: (value) => value ?? t("(não informado)"),
    },
    {
      title: t("Conteúdo"),
      dataIndex: "conteudo",
      key: "conteudo",
      sorter: (a, b) => compareStrings(a.conteudo, b.conteudo),
      render: (text) => <TableCellEllipsis text={text} maxLength={20} />,
      width: 100,
    },
    {
      title: t("Observação"),
      dataIndex: "obs",
      key: "obs",
      sorter: (a, b) => compareStrings(a.obs, b.obs),
      render: (text) => <TableCellEllipsis text={text} maxLength={20} />,
      width: 100,
    },
    {
      title: t("Criado em"),
      dataIndex: "createdAt",
      key: "createdAt",
      hidden: true,
      render: (value) => formatDate(value),
    },
    {
      title: t("Atualizado em"),
      dataIndex: "updatedAt",
      key: "updatedAt",
      hidden: true,
      render: (value) => formatDate(value),
    },
  ];

  return (
    <MiniTable
      ref={miniTableRef}
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      title={title}
      rowSelection={{
        selectedRowKeys: selectedIds,
        onChange: onSelectedIdsChange,
      }}
      scroll={{
        y: "auto",
      }}
    />
  );
}

EmpresaLicencasTable.propTypes = {
  dataSource: PropTypes.array,
  loading: PropTypes.bool,
  miniTableRef: PropTypes.object,
  onClick: PropTypes.func,
  onSelectedIdsChange: PropTypes.func,
  selectedIds: PropTypes.arrayOf(PropTypes.number),
  title: PropTypes.func,
};
